export const validateEmail = (email: string) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
}


export const getCaptchaToken = async () => await grecaptcha.enterprise.execute('6Lc6smMpAAAAAHNYtffUPG1UPsXiLRZ7Eya7NWV1', {action:'validate_captcha'})
  